import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  AppStoreIcon,
  SigninLanding,
  GooglePlayIcon,
  WebLogoMain,
  LandingBgImg,
  PersonalLogo,
  FeaturedIcon,
  AddUserIcon,
  HearIcon,
  AuthArrow,
  PasswordIcon,
  UserIcon,
  PhoneIcon,
  LoginMailIcon,
  FaqDownIcon,
  TwoPhones,
  BlackGooglePlay,
  BlackAppStore,
  WebLogo,
  InstaIcon,
  BlackLogoStore,
  BlackLogoPlay,
  TwitterIcon,
  YoutubeIcon,
  EmotionaIcon,
  MemoryIcon,
  InsightIcon,
  CalenderIconLand,
  SetPreferences,
  EnjoySbscription,
  TrustedIcon,
  ManagementIcon,
} from "../utils/Images";
import Carousel from "../components/Carousel";
import { Field, Form, Formik } from "formik";
import { cousntryCodesArr } from "../utils/constants";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  checkavailability,
  getproductisting,
  sendotp,
} from "../collection/ApiCollection";
import RegisterSteps from "../auth/RegisterSteps";
import SubscriptionCarousel from "../components/SubscriptionCarousel";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import HeroSection from "../components/HeroSection";
import TopHeader from "../components/TopHeader"
import { BsArrowRightCircle } from "react-icons/bs";
import { Icon } from "@chakra-ui/react";

const Landing = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showFaqOne, setShowFaqOne] = useState(false);
  const [showFaqTwo, setShowFaqTwo] = useState(false);
  const [showFaqThree, setShowFaqThree] = useState(false);
  const [showFaqFour, setShowFaqFour] = useState(false);
  const [showFaqFive, setShowFaqFive] = useState(false);
  const [showFaqSix, setShowFaqSix] = useState(false);
  const [showFaqSeven, setShowFaqSeven] = useState(false);
  const [showFaqEight, setShowFaqEight] = useState(false);
  const [showFaqNine, setShowFaqNine] = useState(false);
  const [showFaqTen, setShowFaqTen] = useState(false);
  const [showFaqEleven, setShowFaqEleven] = useState(false);
  const [showFaqTwelve, setShowFaqTwelve] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [modalData, setModalData] = useState(null);
  const [carouselListing, setCarouselListing] = useState(null);
  console.log(carouselListing, "carouselListing");
  const [openRegisterStepsModal, setOpenRegisterStepsModal] = useState(false);
  const [countryCode, setCountryCode] = useState("+1");
  const isPhoneNumber = (value) => {
    return /^\d+$/.test(value) && value.length > 6; // Adjust length check based on typical phone numbers
  };
  const handleOpenRegisterStepsModal = () => {
    setOpenRegisterStepsModal(true);
  };
  const handleCancelRegisterStepsModal = () => {
    setOpenRegisterStepsModal(false);
  };

  const checkType = isPhoneNumber(inputValue);
  const handleInputCheck = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };
  const initialValues = {
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
  };
  const validationSchema = Yup.object().shape({
    fullName: Yup.string()
      .matches(
        /^[A-Za-z\s]+$/,
        "Full Name cannot contain numbers or special characters"
      )
      .required("Full Name is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      )
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const handleGetProductListing = async () => {
    try {
      setLoader(true);
      let res = await getproductisting();
      if (res.status === 200) {
        setLoader(false);
        const products = res?.data?.data?.data || [];
        const pricingPlans = products.map((item) => item.pricing).flat();
        setCarouselListing(pricingPlans);
      } else {
        setLoader(false);
        toast.error(
          res?.response?.data?.message ||
          res?.error ||
          res?.message ||
          "Something went wrong"
        );
      }
    } catch (error) {
      setLoader(false);
      toast.error(
        error?.response?.data?.message ||
        error?.error ||
        error?.message ||
        "Something went wrong"
      );
    }
  };

  const handleCheckAvailibility = async (values) => {
    if (inputValue == "") {
      toast.error("Email or number is required");
      return;
    }
    setModalData(values);

    try {
      setLoader(true);
      const params = new URLSearchParams();
      if (checkType) {
        params.append("phoneNumber", inputValue);
        params.append("countryCode", countryCode);
      } else {
        params.append("email", inputValue);
      }
      let res = await checkavailability(params.toString());
      console.log(res, "availll");
      if (res.status === 200) {
        const reqForNum = {
          phoneNumber: inputValue,
          countryCode: countryCode,
          type: "sms",
        };
        const reqForEmail = {
          email: inputValue,
          type: "email",
        };
        try {
          let res = await sendotp(checkType ? reqForNum : reqForEmail);
          if (res.status === 200) {
            toast.success(res?.data?.message);
            handleOpenRegisterStepsModal();
            setLoader(false);
          } else {
            console.log(res);
            toast.error(
              res?.response?.data?.message ||
              res?.error ||
              res?.message ||
              "Something went wrong"
            );
            setLoader(false);
          }
        } catch (error) {
          console.log(error);
          toast.error(
            error?.response?.data?.message ||
            error?.error ||
            error?.message ||
            "Something went wrong"
          );
          setLoader(false);
        }
      } else {
        toast.error(
          res?.response?.data?.message ||
          res?.error ||
          res?.message ||
          "Something went wrong"
        );
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      toast.error(
        error?.response?.data?.errors?.[0]?.msg ||
        error?.response?.data?.message ||
        error?.error ||
        error?.message ||
        "Something went wrong"
      );
      setLoader(false);
    }
  };

  useEffect(() => {
    handleGetProductListing();
  }, []);

  return (
    <>
      <TopHeader />
      <LandingWrapper>
        {loader && <Loader />}
        {openRegisterStepsModal && (
          <RegisterSteps
            openRegisterStepsModal={openRegisterStepsModal}
            handleCancelRegisterStepsModal={handleCancelRegisterStepsModal}
            inputValue={inputValue}
            countryCode={countryCode}
            checkType={checkType}
            modalData={modalData}
          />
        )}
        <HeroSection />
        <div className="second-section">
          <h1 className="sophie-helps">How Sophie Helps Your Loved Ones.</h1>
          <div className="card-row">
            <div className="card">
              <img src={PersonalLogo} alt="" />
              <h1 className="">Personalized Conversation</h1>
              <p>
                Daily calls tailored to your loved one's preferences and
                interests.
              </p>
            </div>
            <div className="card">
              <img src={EmotionaIcon} alt="" />
              <h1 className="">Emotional Support</h1>
              <p>
                Providing friendly companionship to reduce loneliness and uplift
                spirits.
              </p>
            </div>
            <div className="card">
              <img src={MemoryIcon} alt="" />
              <h1 className="">Cognitive Stimulation</h1>
              <p>
                Engaging discussions and activities to keep the mind active and
                sharp.
              </p>
            </div>
            <div className="card">
              <img src={InsightIcon} alt="" />
              <h1 className="">Caregiver Insights</h1>
              <p>Receive summaries and insights about engagement levels.</p>
            </div>
            <div className="card">
              <img src={CalenderIconLand} alt="" />
              <h1 className="">Easy Scheduling</h1>
              <p>Set up daily or weekly calls with a few simple clicks.</p>
            </div>
          </div>
        </div>
        <div className="fourth-section">
          <Carousel />
        </div>
        <div className="third-section">
          <div className="left-section">
            <img src={FeaturedIcon} alt="" />
            <p>Getting Started is Simple.</p>
          </div>
          <div className="right-section">
            <div className="card-div">
              <div className="card">
                <img src={AddUserIcon} alt="" />
                <div>
                  <h1>Sign Up</h1>
                  <p>Create an account and add your loved one's details</p>
                </div>
              </div>
            </div>
            <div className="card-div" style={{ marginTop: "32px" }}>
              <div className="card">
                <img src={SetPreferences} alt="" />
                <div>
                  <h1>Set Preferences</h1>
                  <p>Schedule daily calls and customize conversations.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="card-div">
              <div className="card">
                <img src={EnjoySbscription} alt="" />
                <div>
                  <h1>Enjoy the Connection</h1>
                  <p>
                    Sophie takes care of the rest, providing companionship and
                    support.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="fifth-section">
          <h1 className="choose-sophie">Why Choose Sophie</h1>
          <p className="sophie-para">
            Life is short why spent to design from scratch, Use finalui templates
            and its <br /> dummy text like lorem ipsum dolor sit amet, consectetur
            adipiscing elit.
          </p>
          <div className="cards-row">
            <div className="card">
              <img src={HearIcon} alt="" />
              <div>
                <h1>Peace of Mind</h1>
                <p>Know your loved ones are cared for and engaged every day.</p>
              </div>
            </div>
            <div className="card-2">
              <img src={TrustedIcon} alt="" />
              <div>
                <h1>Trusted by Experts</h1>
                <p>
                  Sophie is endorsed by professionals in elderly care, including
                  geriatricians, psychologists, and cognitive health specialists.
                  Developed with input from experts in mental health and aging,
                  Sophie's approach is rooted in research on combating loneliness
                  and promoting cognitive engagement. Its features are designed to
                  provide meaningful emotional support and mental stimulation,
                  backed by scientifically informed techniques to enhance the
                  well-being of elderly individuals.
                </p>
              </div>
            </div>
            <div className="card">
              <img src={ManagementIcon} alt="" />
              <div>
                <h1>Simple Management</h1>
                <p>Easily schedule calls and receive updates from anywhere.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="subscription-section">
          <SubscriptionCarousel carouselListing={carouselListing} />
          <div className="button-div">
            <button
              className="sign-for-free"
              onClick={() => navigate("/onboarding")}
            >
              SIGN UP FOR FREE TODAY
            </button>
          </div>
        </div>
        {/* <div className="seventh-section">
          <p>Ready to Make a Difference? Try Sophie Free for 30 Days.</p>
          <div className="input-divs">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleCheckAvailibility}
            >
              {({ errors, touched }) => (
                <Form>
                  <div className="input-div">
                    <div>
                      <img src={UserIcon} alt="" className="mail-icon" />
                      <Field
                        type="text"
                        name="fullName"
                        placeholder="Full name"
                      />
                    </div>
                    {errors.fullName && touched.fullName && (
                      <p
                        className="error-div"
                        style={{ fontSize: "16px", fontWeight: "400" }}
                      >
                        {errors.fullName}
                      </p>
                    )}
                    <div style={{ border: "none", padding: "0px" }}>
                      {isPhoneNumber(inputValue) && (
                        <select
                          value={countryCode}
                          onChange={(e) => setCountryCode(e.target.value)}
                          style={{ marginRight: "8px" }}
                          className="country-code"
                        >
                          {cousntryCodesArr?.map((val) => {
                            return (
                              <option value={val?.code}>
                                {val?.code} {val?.name}
                              </option>
                            );
                          })}
                        </select>
                      )}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "0px",
                        }}
                      >
                        <input
                          type="text"
                          value={inputValue}
                          onChange={handleInputCheck}
                          placeholder="Email or Phone number"
                        />
                        <img
                          src={
                            isPhoneNumber(inputValue) ? PhoneIcon : LoginMailIcon
                          }
                          alt=""
                          className="mail-icon"
                        />
                      </div>
                    </div>
                    <div>
                      <img src={PasswordIcon} alt="" className="mail-icon" />
                      <Field
                        type="password"
                        name="password"
                        placeholder="Enter password"
                      />
                    </div>
                    {errors.password && touched.password && (
                      <p
                        className="error-div"
                        style={{ fontSize: "16px", fontWeight: "400" }}
                      >
                        {errors.password}
                      </p>
                    )}
                    <div>
                      <img src={PasswordIcon} alt="" className="mail-icon" />
                      <Field
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm password"
                      />
                    </div>
                    {errors.confirmPassword && touched.confirmPassword && (
                      <p
                        className="error-div"
                        style={{ fontSize: "16px", fontWeight: "400" }}
                      >
                        {errors.confirmPassword}
                      </p>
                    )}
                  </div>
                  <div className="signin-method">
                    <button type="submit">
                      Sign Up <Icon ml="auto" as={BsArrowRightCircle} />
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div> */}
        <div className="eighth-section">
          <div className="left-section">
            <h1>FAQs</h1>
            <p>Have Questions? We've Got Answers.</p>
          </div>
          <div className="right-section">
            <div className="right-inner">
              <div onClick={() => setShowFaqOne(!showFaqOne)}>
                <p>How does Sophie help my loved one?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqOne ? "180deg" : "" }}
                />
              </div>
              {showFaqOne && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  Sophie provides personalized daily phone calls that reduce
                  loneliness, boost happiness, and keep the mind sharp through
                  engaging conversations tailored to your loved one's interests.
                </p>
              )}
            </div>
            <div className="right-inner">
              <div onClick={() => setShowFaqTwo(!showFaqTwo)}>
                <p>What happens after the free trial?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqTwo ? "180deg" : "" }}
                />
              </div>
              {showFaqTwo && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  After the 30-day free trial, users can choose to continue with a
                  subscription plan or switch to the pay-as-you-go option. Billing
                  will occur automatically based on the selected plan.
                </p>
              )}
            </div>
            <div className="right-inner">
              <div onClick={() => setShowFaqThree(!showFaqThree)}>
                <p>Can I review call summaries?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqThree ? "180deg" : "" }}
                />
              </div>
              {showFaqThree && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  Yes, caregivers can access call summaries and insights through
                  their dashboard to stay informed about engagement levels and
                  overall well-being.
                </p>
              )}
            </div>

            <div className="right-inner">
              <div onClick={() => setShowFaqFour(!showFaqFour)}>
                <p>What is Sophie and how does it work?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqFour ? "180deg" : "" }}
                />
              </div>
              {showFaqFour && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  Sophie is an AI-powered companion designed to engage in
                  meaningful, personalized phone conversations with your loved
                  ones. It provides emotional support, cognitive stimulation, and
                  companionship, ensuring they never feel alone.
                </p>
              )}
            </div>
            <div className="right-inner">
              <div onClick={() => setShowFaqFive(!showFaqFive)}>
                <p>How do I know my loved one is enjoying the calls?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqFive ? "180deg" : "" }}
                />
              </div>
              {showFaqFive && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  You'll receive regular insights and summaries of each
                  conversation through your dashboard, helping you stay connected
                  and reassured about their experience.
                </p>
              )}
            </div>
            <div className="right-inner">
              <div onClick={() => setShowFaqSix(!showFaqSix)}>
                <p>Will Sophie remember past conversations?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqSix ? "180deg" : "" }}
                />
              </div>
              {showFaqSix && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  Yes! Sophie retains key details from previous conversations,
                  such as favorite topics, hobbies, and interests, to make each
                  call feel familiar and personal.
                </p>
              )}
            </div>
            <div className="right-inner">
              <div onClick={() => setShowFaqSeven(!showFaqSeven)}>
                <p> Can I customize the conversations?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqSeven ? "180deg" : "" }}
                />
              </div>
              {showFaqSeven && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  Absolutely! You can update preferences at any time—choosing
                  topics, tone, and even setting reminders for Sophie to ask about
                  specific things your loved one enjoys.
                </p>
              )}
            </div>
            <div className="right-inner">
              <div onClick={() => setShowFaqEight(!showFaqEight)}>
                <p>What if my loved one has trouble hearing or understanding?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqEight ? "180deg" : "" }}
                />
              </div>
              {showFaqEight && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  Sophie is designed to speak slowly, clearly, and with patience,
                  ensuring a smooth and comfortable experience. It also adjusts
                  its speech based on responses.
                </p>
              )}
            </div>
            <div className="right-inner">
              <div onClick={() => setShowFaqNine(!showFaqNine)}>
                <p>Is my loved one's information safe?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqNine ? "180deg" : "" }}
                />
              </div>
              {showFaqNine && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  Yes, privacy and security are our top priorities. All
                  conversations and data are securely stored and encrypted to
                  protect your loved one's personal information.
                </p>
              )}
            </div>
            <div className="right-inner">
              <div onClick={() => setShowFaqTen(!showFaqTen)}>
                <p>
                  {" "}
                  What happens if Sophie detects signs of distress or concern?
                </p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqTen ? "180deg" : "" }}
                />
              </div>
              {showFaqTen && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  Sophie is designed to recognize unusual patterns in
                  conversation. If signs of distress or loneliness are detected,
                  an alert will be sent to you, ensuring you can step in when
                  needed.
                </p>
              )}
            </div>

            <div className="right-inner">
              <div onClick={() => setShowFaqEleven(!showFaqEleven)}>
                <p>What if we need more calls than our plan allows?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqEleven ? "180deg" : "" }}
                />
              </div>
              {showFaqEleven && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  You can easily add extra calls as needed through our flexible
                  pay-as-you-go option.
                </p>
              )}
            </div>
            <div className="right-inner">
              <div onClick={() => setShowFaqTwelve(!showFaqTwelve)}>
                <p>Can I try Sophie before committing to a plan?</p>
                <img
                  src={FaqDownIcon}
                  alt=""
                  style={{ rotate: showFaqTwelve ? "180deg" : "" }}
                />
              </div>
              {showFaqTwelve && (
                <p style={{ margin: "10px 0px 0px 0px" }}>
                  Yes! We offer a 30-day free trial so you can experience
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="nineth-section">
          <div className="left-section">
            <div className="content">
              <h1>Connect with AI in Real-Time from your mobile</h1>
              <p>
                Transforming Loneliness into Connection: Discover Sophie, the
                AI-powered companion for seniors.
              </p>
              <div className="get-the-app">
                <h1>Get the App</h1>
                <div>
                  <img
                    src={BlackGooglePlay}
                    alt=""
                    style={{ display: "inline" }}
                  />
                  <img src={BlackAppStore} alt="" style={{ display: "inline" }} />
                </div>
              </div>
            </div>
          </div>
          <img src={TwoPhones} alt="" />
        </div>
        <div className="footer">
          <div className="footer-div-1">
            <img src={WebLogo} alt="" />
            <p>
              <span onClick={() => navigate("/about")}>About Us</span>
              <span onClick={() => navigate("/landing/conditions")}>
                Terms of Services
              </span>
              <span onClick={() => navigate("/landing/policy")}>
                Privacy Policy
              </span>
            </p>
            <h4>© 2025 Sophie. All rights reserved</h4>
          </div>
          <div className="footer-div-2">
            {/* <p>+1 6623748592</p> */}
            <p>support@sophie-care.com</p>
          </div>
          <div className="footer-div-3">
            <div>
              <a
                href="https://www.instagram.com/sophiecare26?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr"
                target="_blank"
              >
                <img src={InstaIcon} alt="" />
              </a>
            </div>
            <div>
              <a href="https://x.com/sophiecare26?s=21" target="_blank">
                <img src={TwitterIcon} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://youtube.com/@sophiecare26?feature=shared"
                target="_blank"
              >
                <img src={YoutubeIcon} alt="" />
              </a>
            </div>
          </div>
          <div className="footer-div-4">
            <h1>Get the App</h1>
            <img src={BlackLogoStore} alt="" />
            <img src={BlackLogoPlay} alt="" />
          </div>
        </div>
      </LandingWrapper>
    </>
  );
};

export default Landing;

const LandingWrapper = styled.div`
  .first-sectoion {
    height: 100%;
    padding-bottom: 40px;
    background-image: url(${LandingBgImg});
    background-size: cover;

    @media (max-width: 1000px) {
      background-position: 50% 50%;
    }

    .header {
      display: flex;
      justify-content: space-between;
      padding: 20px 70px;

      @media (max-width: 600px) {
        padding: 20px;
      }

      @media (max-width: 400px) {
        flex-direction: column;
        align-items: center;
      }

      img {
        width: 80px;
        height: 68px;
      }

      .header-right {
        display: flex;
        align-items: center;
        gap: 14px;

        @media (max-width: 400px) {
          justify-content: center;
          margin-top: 20px;
        }

        p {
          color: #fff;
          font-weight: 700;
          font-size: 15px;
          cursor: pointer;
          margin-bottom: 0px;
        }
        button {
          background: #108084;
          color: #fff;
          height: 44px;
          border-radius: 27px;
          font-weight: 700;
          font-size: 13px;
          padding: 0px 20px;
          border: none;
        }
      }
    }
    .header-content {
      padding: 179px 64px 0px 67px;

      @media (max-width: 380px) {
        padding: 150px 64px 0px 67px;
      }

      .para {
        color: #fff;
        font-weight: 700;
        font-size: 27px;
        text-align: center;
        line-height: 35px;

        @media (max-width: 420px) {
          font-size: 20px;
        }
      }
      .trial {
        color: #fff;
        font-weight: 400;
        font-size: 23px;
        margin-top: 65px;
        text-align: center;
      }
      .get-start {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 24px;
        margin-bottom: 39px;
        button {
          background: #108084;
          border-radius: 15px;
          border: none;
          height: 58px;
          padding: 0px 25px;
          color: #fff;
          font-weight: 700;
          font-size: 18px;
          cursor: pointer;
        }
      }
      .download-link {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 13px;

        @media (max-width: 500px) {
          flex-direction: column;
        }

        img {
          width: 211px;
          height: 61px;
        }
      }
    }
  }
  .second-section {
    padding: 0px 112px 0px 112px;
    margin-top: 30px;

    @media (max-width: 900px) {
      padding: 0px 56px 0px 56px;
    }

    .sophie-helps {
      color: #111827;
      font-weight: 700;
      font-size: 48px;
      margin-bottom: 48px;

      @media (max-width: 920px) {
        font-size: 32px;
      }
      @media (max-width: 660px) {
        font-size: 28px;
      }
    }
    .card-row {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 32px;

      @media (max-width: 920px) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media (max-width: 640px) {
        grid-template-columns: repeat(1, 1fr);
      }
      .card {
        width: 100%;
        img {
          width: 39px;
          height: 39px;
          margin-bottom: 24px;
        }
        h1 {
          color: #111827;
          font-weight: 700;
          font-size: 30px;
          margin-bottom: 8px;

          @media (max-width: 660px) {
            font-size: 22px;
          }
        }
        p {
          color: #374151;
          font-weight: normal;
          font-size: 16px;
        }
      }
    }
  }
  .third-section {
    padding: 0px 112px 0px 112px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
    margin-top: 50px;

    @media (max-width: 900px) {
      padding: 0px 56px 0px 56px;
    }
    @media (max-width: 975px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 975px) {
      grid-template-columns: repeat(1, 1fr);
    }

    .left-section {
      display: flex;
      flex-direction: column;
      gap: 24px;
      img {
        width: 56px;
        height: 56px;
      }
      p {
        color: #101828;
        font-weight: 600;
        font-size: 42px;

        @media (max-width: 1200px) {
          font-size: 28px;
        }
      }
    }
    .right-section {
      .card-div {
        .card {
          display: flex;
          flex-direction: column;
          gap: 64px;
          padding: 24px;
          background: #56D9B91A;
          border-radius: 12px;
          img {
            width: 48px;
            height: 48px;
          }
          div {
            display: flex;
            flex-direction: column;
            gap: 8px;
            h1 {
              color: 101828;
              font-weight: 600;
              font-size: 20px;
            }
            p {
              color: #475467;
              font-weight: normal;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .fifth-section {
    padding: 0px 112px 0px 112px;
    margin-top: 80px;

    @media (max-width: 900px) {
      padding: 0px 56px 0px 56px;
    }

    .choose-sophie {
      color: #14181f;
      font-weight: 600;
      font-size: 48px;
      margin-bottom: 12px;
      text-align: center;

      @media (max-width: 650px) {
        font-size: 32px;
      }
    }
    .sophie-para {
      color: #525e6f;
      font-weight: normal;
      font-size: 20px;
      text-align: center;
    }
    .cards-row {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      margin-top: 60px;

      @media (max-width: 1300px) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media (max-width: 931px) {
        grid-template-columns: repeat(1, 1fr);
      }

      .card-2 {
        background: #56D9B91A;
        border-radius: 18px;
        padding: 16px;
        display: flex;
        gap: 20px;
        height: 466px;

        @media (max-width: 470px) {
          flex-direction: column;
          height: 100%;
        }

        img {
          width: 56px;
          height: 56px;
        }
        div {
          h1 {
            color: #14181f;
            font-weight: 600;
            font-size: 18px;
            margin-bottom: 8px;
          }
          p {
            color: #6f7c8e;
            font-weight: 400;
            line-height: 24px;
            font-size: 16px;
          }
        }
      }

      .card {
        background: #56D9B91A;
        border-radius: 18px;
        padding: 16px;
        display: flex;
        gap: 20px;
        height: 466px;

        @media (max-width: 931px) {
          flex-direction: column;
        }

        img {
          width: 56px;
          height: 56px;
        }
        div {
          h1 {
            color: #14181f;
            font-weight: 600;
            font-size: 18px;
            margin-bottom: 8px;
          }
          p {
            color: #6f7c8e;
            font-weight: 400;
            line-height: 24px;
            font-size: 16px;
          }
        }
      }
    }
  }
  .subscription-section {
    .button-div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      .sign-for-free {
        height: 58px;
        background: #108084;
        color: #fff;
        border-radius: 15px;
        padding: 0px 27px;
        border: none;
        cursor: pointer;
      }
    }
  }
  .seventh-section {
    background-image: url(${SigninLanding});
    padding: 101px 0px;
    background-size: cover;
    margin-top: 100px;
    p {
      color: #fff;
      font-weight: 700;
      font-size: 21px;
      margin-bottom: 41px;
      text-align: center;
    }
    .input-divs {
      .input-div {
        div {
          margin: auto;
          margin-top: 31px;
          border: 1px solid #e4dfdf;
          border-radius: 12px;
          height: 70px;
          display: flex;
          align-items: center;
          gap: 15px;
          position: relative;
          max-width: 383px;
          width: 100%;

          .country-code {
            height: 70px;
            border-radius: 12px;
            border: 1px solid #e4dfdf;
          }

          .mail-icon {
            width: 27px;
            height: 27px;
            position: absolute;
            z-index: 9;
            left: 20px;
          }
          .eye-icon {
            width: 29px;
            height: 30px;
            position: absolute;
            z-index: 9;
            right: 20px;
          }
          input {
            font-size: 14px;
            font-weight: 400;
            border: none;
            height: 100%;
            position: relative;
            padding: 0px 60px;
            border-radius: 12px;
            width: 100%;

            &:focus {
              outline: none;
            }
          }
        }
        .error-div {
          color: red;
          margin-top: 5px;
          margin-left: 13px;

          @media (max-width: 1050px) {
            width: max-content;
            margin: auto;
            margin-top: 5px;
          }
        }
      }
    }
    .signin-method {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 48px;

      button {
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        background: #108084;
        height: 48px;
        padding: 0px 30px;
        position: relative;
        border: none;
        border-radius: 15px;
        display: flex;
        align-items: center;
        max-width: 225px;
        width: 100%;
        justify-content: center;
        cursor: pointer;

        svg {
          position: absolute;
          width: 24px;
          height: 24px;
          right: 10px;
        }
      }
    }
  }
  .eighth-section {
    display: flex;
    gap: 34px;
    padding: 0px 112px;
    margin-top: 80px;
    margin-bottom: 100px;

    @media (max-width: 900px) {
      padding: 0px 56px 0px 56px;
    }
    @media (max-width: 875px) {
      display: block;
    }

    .left-section {
      width: 50%;
      h1 {
        color: #14181f;
        font-weight: 600;
        font-size: 48px;
      }
      p {
        color: #525e6f;
        font-weight: 500;
        font-size: 18px;
        margin-top: 16px;
      }
    }
    .right-section {
      width: 50%;
      @media (max-width: 875px) {
        width: 100%;
      }
      .right-inner {
        padding: 16px 0px;
        border-bottom: 1px solid #dce0e5;
        div {
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;

          p {
            color: #14181f;
            font-weight: 700;
            font-size: 18px;
            margin-bottom: 0px;
          }
          img {
            width: 24px;
            height: 24px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .nineth-section {
    background: #108084;
    display: flex;
    gap: 32px;
    padding: 0px 112px;

    @media (max-width: 1050px) {
      flex-direction: column;
      padding-top: 40px;
    }
    @media (max-width: 900px) {
      padding: 0px 56px 0px 56px;
    }

    .left-section {
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: 1050px) {
        padding-bottom: 40px;
      }
      @media (max-width: 600px) {
        padding-top: 40px;
      }

      .content {
        h1 {
          color: #fff;
          font-weight: 700;
          font-size: 48px;
        }
        p {
          color: #fff;
          font-weight: 500;
          font-size: 18px;
          margin-top: 15px;
        }
        .get-the-app {
          margin-top: 48px;
          h1 {
            color: #fff;
            font-weight: 700;
            font-size: 18px;
          }
          div {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-top: 10px;
            img {
              width: 135px;
              height: 40px;
            }
          }
        }
      }
    }
    img {
      height: 588px;

      @media (max-width: 600px) {
        display: none;
      }
    }
  }
  .footer {
    background: #000;
    width: 100%;
    padding: 64px 112px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 82px;

    @media (max-width: 1250px) {
      padding: 64px 40px 64px 40px;
    }
    @media (max-width: 1150px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 780px) {
      grid-template-columns: repeat(1, 1fr);
    }

    .footer-div-1 {
      @media (max-width: 420px) {
        text-align: center;
      }
      img {
        width: 70px;
        height: 29px;
      }
      p {
        display: flex;
        align-items: center;
        gap: 24px;
        margin-top: 60px;
        margin-bottom: 24px;

        @media (max-width: 420px) {
          flex-direction: column;
        }

        span {
          color: #fff;
          font-weight: 400;
          font-size: 16px;
          cursor: pointer;
          white-space: nowrap;
        }
      }
      h4 {
        color: #d1d5db;
        font-weight: 400;
        font-size: 14px;

        @media (max-width: 420px) {
          text-align: center;
        }
      }
    }
    .footer-div-2 {
      display: flex;
      align-items: end;
      gap: 29px;

      @media (max-width: 420px) {
        justify-content: center;
      }
      @media (max-width: 350px) {
        flex-direction: column;
        align-items: center;
      }

      p {
        color: #fff;
        font-weight: 400;
        font-size: 16px;
        margin-bottom: 0px;
        white-space: nowrap;
      }
    }
    .footer-div-3 {
      display: flex;
      gap: 16px;
      align-items: end;

      @media (max-width: 420px) {
        justify-content: center;
      }

      div {
        img {
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }
    }
    .footer-div-4 {
      display: flex;
      flex-direction: column;
      gap: 16px;
      justify-content: end;

      @media (max-width: 420px) {
        align-items: center;
      }

      h1 {
        color: #d1d5db;
        font-weight: 500;
        font-size: 18px;
      }
      img {
        width: 135px;
        height: 40px;
        cursor: pointer;
      }
    }
  }
`;
